import script from "./ProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductList.vue?vue&type=script&setup=true&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=7c995506&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c995506"]])

export default __exports__